export default __webpack_public_path__ + "static/media/change_bg.3fd38fb6.png";